import React from 'react'

function Icon(props: any) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="258"
            height="252"
            fill="none"
            viewBox="0 0 258 252"
            {...props}
        >
            <g opacity="0.3">
                <path
                    fill="#C4ECFE"
                    d="M239.563 18.83V206.5H18.386V18.83h221.177zm.723-.723H17.663v189.116h222.623V18.107z"
                    opacity="0.3"
                ></path>
                <g opacity="0.3">
                    <path
                        fill="#C4ECFE"
                        d="M240.286 152.18H17.663v.677h222.623v-.677zM240.286 125.09H17.663v.677h222.623v-.677z"
                        opacity="0.3"
                    ></path>
                    <path
                        fill="#C4ECFE"
                        d="M240.286 152.18H17.663v.677h222.623v-.677zM240.286 179.247H17.663v.677h222.623v-.677zM240.286 98.024H17.663v.676h222.623v-.676zM240.286 70.933H17.663v.677h222.623v-.677zM240.286 43.867H17.663v.677h222.623v-.677z"
                        opacity="0.3"
                    ></path>
                </g>
            </g>
            <path
                fill="url(#paint0_linear)"
                d="M175.023 207.223c18.574 0 17.99-28.186 34.16-31.92 6.464-1.493 9.964-6.253 12.95-11.456 4.97-8.634 18.154-5.134 18.154 4.83v38.546h-65.264z"
            ></path>
            <path
                fill="#BFD9FF"
                d="M228.271 67.807a.957.957 0 100-1.915.957.957 0 000 1.915zM113.774 162.797a.958.958 0 10-.001-1.915.958.958 0 00.001 1.915zM193.295 29.167a.956.956 0 100-1.913.956.956 0 000 1.913zM133.724 60.433a.957.957 0 100-1.913.957.957 0 000 1.913zM25.597 62.253a.957.957 0 100-1.913.957.957 0 000 1.913zM199.967 133.957a.887.887 0 10-.001-1.773.887.887 0 00.001 1.773zM30.31 136.057a.887.887 0 100-1.774.887.887 0 000 1.774z"
            ></path>
            <path
                fill="#BE6361"
                d="M83.323 57.843v51.637c0 7.724-6.254 13.977-13.977 13.977h-18.55c-7.723 0-13.977-6.253-13.977-13.977V57.843"
            ></path>
            <path
                fill="#000046"
                d="M36.82 57.843c0-7.723 6.253-13.976 13.976-13.976h18.55c7.723 0 13.977 6.253 13.977 13.976"
            ></path>
            <path
                fill="url(#paint1_linear)"
                d="M72.52 79.077l-3.127-11.713c-1.284-4.784 1.563-9.707 6.37-10.99 4.783-1.284 9.706 1.563 10.99 6.37l3.36 12.6"
            ></path>
            <path
                fill="#FDC068"
                d="M90.113 75.32l5.226 19.6-1.003-2.333 14.49 28.746a6.48 6.48 0 01-2.87 8.704c-2.893 1.446-6.347.536-8.19-2.007l-18.807-26.133a6.076 6.076 0 01-.863-1.797l-.14-.56-5.483-20.51"
            ></path>
            <path fill="#000046" d="M87.64 89.833l8.493 36.19-9.847-13.696 1.353-22.494z"></path>
            <path
                fill="url(#paint2_linear)"
                d="M87.173 84.817c.397-8.797-5.67-8.657-3.08-14.444 2.59-5.786.28-14.21-6.463-14.49-5.203-.233-5.553-.466-7.747-.56-6.93-.303-12.04 6.534-10.336 13.277 0 0 .466 1.517.326 3.5s-5.156 4.713-5.413 10.733l32.713 1.984z"
            ></path>
            <path
                fill="#000046"
                d="M85.703 77.957l-1.984-3.477.537-2.706c1.213-4.34-.257-8.984-3.71-11.877l-5.437-4.503 2.24-2.684 5.437 4.504c4.527 3.756 6.44 9.846 4.853 15.493l-1.936 5.25z"
            ></path>
            <path
                fill="url(#paint3_linear)"
                d="M87.196 84.28s1.19 14.187 1.4 16.543c.444 4.714.77 9.45.98 14.164.444 9.473.537 18.946.35 28.443-.07 4.76-.233 9.497-.42 14.257-.093 2.38-.233 4.76-.326 7.14l-.21 3.57c-.07 1.19-.14 2.38-.234 3.57l-.256 3.57-.28 3.57c-.094 1.19-.21 2.38-.304 3.57l-.163 1.796-.187 1.797-.373 3.593-.187 1.797-.233 1.797c-.163 1.19-.28 2.38-.467 3.593-.186 1.19-.513 3.43-.7 4.62l-16.846-1.12-4.014-55.51-3.57-56.723 26.04-4.037z"
            ></path>
            <path
                fill="url(#paint4_linear)"
                d="M76.206 91.49l-.07.863-.093.864-.163 1.703-.42 3.383c-.14 1.144-.304 2.264-.467 3.384l-.513 3.383c-.7 4.503-1.54 8.96-2.427 13.417-.887 4.456-1.89 8.89-2.917 13.323-1.073 4.433-2.17 8.843-3.36 13.253l-.536 2.03-.094.21c-2.1 4.317-4.27 8.634-6.486 12.904l-1.657 3.22-1.703 3.196c-1.12 2.124-2.31 4.247-3.454 6.37-2.356 4.224-4.76 8.447-7.28 12.6-2.543 4.154-5.086 8.307-7.886 12.367l-15.12-7.817 19.856-52.126-.653 2.263L51.03 86.683l25.176 4.807z"
            ></path>
            <path
                fill="#000046"
                d="M44.1 124.297c6.09-1.96 24.29-.794 26.273 2.24l2.45-11.084-27.883.677-.84 8.167z"
            ></path>
            <path
                fill="url(#paint5_linear)"
                d="M54.46 82.833c-.21 4.644 4.34 11.807 12.412 12.227l6.534.14c7.373.373 13.58-5.903 13.79-10.92l-32.737-1.447z"
            ></path>
            <path
                fill="#FDC068"
                d="M80.616 51.147l-6.066-.584a5.709 5.709 0 01-5.134-6.23l.887-9.146c.49-5.017 4.947-8.68 9.963-8.214 5.017.49 8.68 4.947 8.214 9.964l-.817 8.376c-.327 3.57-3.5 6.184-7.047 5.834z"
            ></path>
            <path
                fill="#000046"
                d="M88.316 38.57l-.186 1.984c-.397-.14-.7-.514-.7-.98 0-.49.396-.934.886-1.004z"
            ></path>
            <path
                fill="#FDC068"
                d="M74.853 61.04l-7.49-3.617 2.497-17.196 9.66.933-.793 17.57c-.094 1.937-2.147 3.15-3.874 2.31z"
            ></path>
            <path
                fill="#000046"
                d="M85.656 42.49a.324.324 0 01-.28-.163.3.3 0 01.14-.397l.863-.42c.094-.046.14-.14.164-.256a.354.354 0 00-.07-.304l-1.144-1.657c-.093-.14-.07-.326.07-.42.14-.093.327-.07.42.07l1.144 1.657c.163.21.21.514.163.77a.965.965 0 01-.467.654l-.023.023-.887.42c0 .023-.046.023-.093.023zM84.49 45.757c-.56 0-1.097-.28-1.634-.84-.116-.117-.116-.327.024-.42.116-.117.326-.117.42.023.443.467.863.677 1.26.654.536-.047.91-.514.91-.537.093-.14.28-.163.42-.07.14.093.163.28.07.42-.024.023-.514.723-1.354.793-.046-.023-.093-.023-.116-.023zM80.104 51.1l-4.994-.49 3.78 4.317 1.214-3.827zM82.53 40.11a1.027 1.027 0 100-2.053 1.027 1.027 0 000 2.053z"
            ></path>
            <path
                fill="#F4E1E1"
                d="M32.2 89.997a.3.3 0 01-.234-.094c-.07-.046-.093-.14-.093-.233l.21-14.56c0-.187.14-.327.327-.327 14.723.094 29.656.35 44.496.607.094 0 .164.047.234.093a.3.3 0 01.093.234 3020.6 3020.6 0 00-.187 14.56c0 .186-.14.303-.326.303a388.23 388.23 0 00-44.52-.583z"
            ></path>
            <path
                fill="#BE6361"
                d="M32.41 75.133c14.816.164 29.656.35 44.473.607-.07 4.853-.14 9.707-.187 14.56a416.195 416.195 0 00-44.497-.607l.21-14.56zm0-.653c-.35 0-.63.28-.654.63l-.21 14.583c0 .164.07.327.187.444.116.116.28.186.443.163a404.5 404.5 0 0144.497.607.616.616 0 00.443-.164.637.637 0 00.187-.443l.21-14.583c0-.35-.28-.654-.63-.654-14.817-.21-29.634-.373-44.474-.583z"
            ></path>
            <path
                fill="#F4E1E1"
                d="M31.803 119.14c-.093.023-.163 0-.233-.07-.07-.047-.093-.117-.093-.21l.21-14.607c0-.186.14-.326.326-.35 14.677-1.493 29.75-1.236 44.497.584a.372.372 0 01.327.35c-.07 4.853-.14 9.683-.187 14.536a.293.293 0 01-.093.21c-.07.047-.14.07-.234.047-14.7-2.59-29.773-2.73-44.52-.49z"
            ></path>
            <path
                fill="#BE6361"
                d="M32.013 104.23a216.57 216.57 0 0144.497.583c-.07 4.83-.14 9.684-.187 14.514-14.84-2.45-29.61-2.59-44.497-.514.047-4.853.117-9.73.187-14.583zm0-.653a.768.768 0 00-.653.7c-.07 4.876-.14 9.753-.187 14.63 0 .163.07.326.187.42.116.093.28.14.443.116 14.887-2.123 29.656-1.983 44.496.514.35.046.63-.187.63-.537.07-4.853.14-9.707.187-14.537 0-.163-.07-.35-.186-.49a.6.6 0 00-.444-.233 222.978 222.978 0 00-44.473-.583z"
            ></path>
            <path
                fill="#D6C1C1"
                d="M32.012 104.557a.392.392 0 01-.233-.07c-.07-.047-.093-.14-.093-.21l.21-14.583c0-.187.14-.327.326-.327 14.724-.7 29.68-.42 44.497.607.093 0 .163.046.233.116a.3.3 0 01.094.234c-.07 4.853-.14 9.706-.187 14.536 0 .187-.14.304-.327.28-14.77-1.866-29.726-2.03-44.52-.583z"
            ></path>
            <path
                fill="#BE6361"
                d="M32.223 89.67c14.84-.56 29.656-.397 44.496.607-.07 4.853-.14 9.683-.186 14.536a216.55 216.55 0 00-44.497-.583c.047-4.853.117-9.707.187-14.56zm-.024-.653c-.35.023-.63.327-.653.677l-.21 14.606c0 .163.07.327.187.443.116.117.28.164.443.14 14.863-1.353 29.657-1.19 44.497.584.35.046.63-.21.653-.56.07-4.854.14-9.707.187-14.56 0-.163-.07-.35-.187-.467a.575.575 0 00-.443-.21c-14.794-1.003-29.61-1.19-44.474-.653.024 0 .024 0 0 0z"
            ></path>
            <path
                fill="#D4B0D6"
                d="M66.733 103.833c-1.704 1.937-3.43 3.874-5.134 5.81-.77.864-2.146 1.004-3.127.28a430.538 430.538 0 00-9.216-6.393c5.833-.093 11.643 0 17.477.303z"
            ></path>
            <path
                fill="#C595C8"
                d="M45.64 89.32c1.446 1.073 2.146 1.61 3.593 2.683-.093 3.757-.21 7.537-.303 11.294l.35.233c5.833-.117 11.643 0 17.476.303a382.575 382.575 0 00-3.243-5.133c3.687-2.847 7.35-5.693 11.013-8.563a426.39 426.39 0 00-28.886-.817z"
            ></path>
            <path
                fill="#D4B0D6"
                d="M45.64 89.32c-1.47-1.727-2.964-3.453-4.434-5.18-1.377-1.703-.77-4.153 1.143-5.133 2.544-1.237 5.087-2.474 7.63-3.687 6.534.093 13.044.163 19.577.28 1.68 4.83 3.337 9.683 4.97 14.537a426.387 426.387 0 00-28.887-.817z"
            ></path>
            <path
                fill="#BE6361"
                d="M57.75 79.637a.332.332 0 01-.28-.14l-.304-.42a.362.362 0 01.07-.49.362.362 0 01.49.07l.303.42a.362.362 0 01-.07.49.376.376 0 01-.21.07zM63.77 88.387c-.117 0-.234-.047-.28-.164-.234-.326-.444-.676-.677-1.003-.117-.163-.07-.373.093-.49.164-.117.374-.07.49.093.234.327.444.677.677 1.004.117.163.07.373-.093.49a.376.376 0 01-.21.07zM61.74 85.4a.305.305 0 01-.28-.163l-.677-1.004c-.117-.163-.07-.373.093-.49.164-.116.374-.07.49.094l.677 1.003c.117.163.07.373-.093.49a.377.377 0 01-.21.07zm-2.077-2.987a.333.333 0 01-.28-.14l-.677-1.003c-.116-.163-.07-.373.094-.49.163-.117.373-.07.49.093l.676 1.004c.117.163.07.373-.093.49a.68.68 0 01-.21.046zM64.4 90.253a.34.34 0 01-.304-.163.373.373 0 01.117-.49.49.49 0 00.14-.093c-.023-.047-.07-.094-.117-.164a.373.373 0 01.117-.49.373.373 0 01.49.117c.047.093.093.14.14.21.047.07.093.14.163.233.094.164.047.374-.093.467-.117.093-.21.14-.303.187-.047.023-.094.046-.164.093-.07.07-.116.093-.186.093zM55.16 96.483c-.117 0-.234-.046-.28-.163-.117-.163-.07-.373.093-.49l1.05-.7c.163-.117.373-.07.49.093.116.164.07.374-.094.49l-1.05.7a.377.377 0 01-.21.07zm3.15-2.123c-.117 0-.234-.047-.28-.163-.117-.164-.07-.374.093-.49l1.05-.7c.163-.117.373-.07.49.093.116.163.07.373-.094.49l-1.05.7a.376.376 0 01-.21.07zm3.15-2.123c-.117 0-.234-.047-.28-.164-.117-.163-.07-.373.093-.49l1.05-.7c.163-.116.373-.07.49.094.116.163.07.373-.094.49l-1.05.7a.376.376 0 01-.21.07zM53.852 98a.332.332 0 01-.28-.14c-.07-.117-.14-.163-.21-.257l-.093-.116a.306.306 0 01-.07-.28c.023-.094.07-.187.163-.234.14-.093.234-.163.35-.233l.07-.047a.362.362 0 01.49.07.362.362 0 01-.07.49l-.07.047c-.023.023-.046.023-.07.047.024.046.047.07.094.116a.362.362 0 01-.07.49c-.093.024-.163.047-.233.047zM57.376 102.293a.43.43 0 01-.28-.116c-.21-.257-.42-.514-.607-.747a.362.362 0 01.047-.49.361.361 0 01.49.047c.187.233.397.466.607.746a.362.362 0 01-.047.49c-.047.047-.14.07-.21.07zm-1.82-2.216a.431.431 0 01-.28-.117c-.187-.233-.373-.467-.607-.747a.362.362 0 01.047-.49.362.362 0 01.49.047c.233.28.42.513.607.747a.362.362 0 01-.047.49c-.047.046-.14.07-.21.07zM58.146 104.09a.375.375 0 01-.257-.117c-.117-.14-.117-.373.047-.49a.964.964 0 00.163-.14c-.023-.046-.07-.07-.093-.116-.117-.14-.117-.374.046-.49.14-.117.374-.117.49.046.14.164.234.28.35.444a.47.47 0 01.07.256.484.484 0 01-.14.234c-.14.116-.233.163-.396.303a.8.8 0 01-.28.07zM52.92 108.15a.362.362 0 01-.233-.63c.326-.257.605-.49.886-.7.163-.117.373-.093.49.047.116.163.093.373-.047.49-.28.21-.56.443-.887.7a.285.285 0 01-.21.093zm2.682-2.123a.366.366 0 01-.28-.14c-.116-.164-.093-.374.07-.49l.91-.7c.164-.117.374-.094.49.07.117.163.094.373-.07.49l-.91.7c-.046.046-.14.07-.21.07zM51.193 109.503a.374.374 0 01-.21-.07l-.42-.303c-.163-.117-.187-.327-.07-.49.116-.163.326-.187.49-.07l.21.163c.07-.046.117-.093.187-.163.14-.117.373-.117.49.047.116.14.116.373-.047.49-.163.14-.28.233-.444.35a.445.445 0 01-.186.046zM49.115 107.963a.374.374 0 01-.21-.07l-.933-.676c-.163-.117-.187-.327-.07-.49.117-.164.327-.187.49-.07l.933.676c.164.117.187.327.07.49a.33.33 0 01-.28.14zm-2.8-2.053a.374.374 0 01-.21-.07l-.933-.677c-.163-.116-.186-.326-.07-.49.117-.163.327-.186.49-.07l.934.677c.163.117.186.327.07.49a.366.366 0 01-.28.14zM43.353 104.417a.382.382 0 01-.21-.07c-.163-.117-.187-.327-.07-.49.117-.164.21-.28.35-.444a.332.332 0 01.467-.046l.42.303c.163.117.186.327.07.49-.117.163-.327.187-.49.07l-.164-.117a.598.598 0 01-.116.14c-.047.117-.14.164-.257.164zM39.97 108.687a.382.382 0 01-.21-.07c-.164-.117-.188-.327-.07-.49.21-.257.396-.514.56-.724a.344.344 0 01.49-.07c.163.117.186.35.07.49-.188.234-.374.467-.56.724a.333.333 0 01-.28.14zm1.703-2.194c-.07 0-.164-.023-.21-.07-.14-.116-.187-.35-.047-.49l.583-.723c.117-.14.35-.187.49-.047.14.117.187.35.047.49l-.584.724a.386.386 0 01-.28.116zM38.733 110.32c-.07 0-.117-.023-.187-.047-.163-.093-.21-.326-.117-.49.094-.14.164-.233.234-.326a.599.599 0 01.116-.14c.117-.164.327-.187.49-.07.164.116.187.326.07.49-.046.07-.093.116-.116.163-.07.093-.117.14-.187.257a.341.341 0 01-.303.163z"
            ></path>
            <path
                fill="#F4E1E1"
                d="M57.423 80.36c-.864 0-1.564-.7-1.564-1.54 0-.816.724-1.493 1.587-1.493h.023c.864 0 1.564.7 1.564 1.54-.024.84-.724 1.493-1.61 1.493.023 0 0 0 0 0z"
            ></path>
            <path
                fill="#BE6361"
                d="M57.446 77.653c.023 0 .023 0 0 0 .7 0 1.26.56 1.26 1.214 0 .653-.56 1.19-1.26 1.19h-.023c-.7 0-1.237-.56-1.237-1.214.023-.653.584-1.19 1.26-1.19zm0-.606c-1.026 0-1.89.793-1.89 1.796-.023 1.004.817 1.82 1.867 1.844h.023c1.027 0 1.89-.794 1.89-1.797 0-.49-.186-.957-.536-1.307-.35-.35-.84-.536-1.33-.56 0 .024 0 .024-.024.024z"
            ></path>
            <path
                fill="#F4E1E1"
                d="M41.93 86.403a1.524 1.524 0 01-1.564-1.516c.023-.84.724-1.517 1.587-1.54h.023c.864 0 1.563.677 1.563 1.517-.023.84-.746 1.54-1.61 1.54.024 0 0 0 0 0z"
            ></path>
            <path
                fill="#BE6361"
                d="M41.953 83.673c.7 0 1.26.537 1.26 1.214 0 .653-.56 1.213-1.26 1.213h-.024c-.7 0-1.236-.537-1.236-1.213 0-.654.56-1.214 1.26-1.214zm0-.63c-1.027.024-1.89.864-1.89 1.867 0 .49.186.957.536 1.307.35.35.817.536 1.33.513h.023c1.027-.023 1.89-.863 1.89-1.843.024-1.004-.816-1.844-1.866-1.82l-.023-.024z"
            ></path>
            <path
                fill="#F4E1E1"
                d="M68.04 99.727a1.726 1.726 0 01-1.12-.514 1.55 1.55 0 01-.443-1.12c0-.84.723-1.47 1.586-1.423h.024c.863.047 1.563.793 1.563 1.633-.023.84-.723 1.47-1.61 1.424.023 0 0 0 0 0z"
            ></path>
            <path
                fill="#BE6361"
                d="M68.063 96.973c.7.047 1.26.63 1.26 1.307 0 .677-.56 1.167-1.26 1.12h-.023a1.322 1.322 0 01-1.237-1.307c.024-.653.56-1.143 1.26-1.12zm0-.63c-1.026-.046-1.89.724-1.89 1.727-.023 1.003.817 1.89 1.867 1.96h.023c1.027.07 1.89-.7 1.89-1.703 0-.49-.186-.98-.536-1.354a1.942 1.942 0 00-1.33-.63h-.024z"
            ></path>
            <path
                fill="#F4E1E1"
                d="M50.844 110.95c-.42 0-.817-.14-1.12-.42a1.393 1.393 0 01-.444-1.05c.024-.817.724-1.517 1.587-1.54h.023c.864 0 1.564.677 1.564 1.517 0 .793-.724 1.47-1.61 1.493.023 0 .023 0 0 0z"
            ></path>
            <path
                fill="#BE6361"
                d="M50.867 108.243c.023 0 .023 0 0 0 .723 0 1.26.537 1.26 1.19 0 .654-.56 1.19-1.26 1.214h-.024c-.7 0-1.26-.514-1.237-1.19a1.277 1.277 0 011.26-1.214zm0-.63c-1.027.024-1.89.864-1.914 1.844 0 .49.187.933.537 1.283.35.327.84.513 1.33.513h.023c1.027-.023 1.89-.84 1.913-1.82 0-.49-.186-.933-.536-1.283a1.89 1.89 0 00-1.33-.537h-.023z"
            ></path>
            <path
                fill="url(#paint6_linear)"
                d="M50.097 65.053l9.473-6.836c4.013-2.894 9.637-1.984 12.53 2.03 2.893 4.013 1.983 9.636-2.03 12.53l-8.633 6.23"
            ></path>
            <path
                fill="#FDC068"
                d="M61.46 79.007L44.752 91.07l3.173-10.407 8.307 29.68c.98 3.454-1.05 7.024-4.503 8.004-3.104.863-6.324-.677-7.63-3.5l-13.044-27.93c-1.68-3.594-.49-7.77 2.59-10.01l.56-.397 15.867-11.433"
            ></path>
            <path
                fill="#000046"
                d="M98.373 206.617l-26.974-.117a2.605 2.605 0 01-2.59-2.543l-.07-3.407 17.034.233 12.903 3.244c1.54.396 1.26 2.613-.303 2.59zM46.853 206.617l-25.037-9.964a2.589 2.589 0 01-1.47-3.313l1.19-3.197 15.774 6.464 10.826 7.746c1.237.887.164 2.847-1.283 2.264z"
            ></path>
            <path
                fill="#5D5D5D"
                d="M88.526 35.723l-11.433-.91-.653 6.044h-3.22l-4.387 6.253 1.563-12.553c.584-4.27 4.48-7.56 8.774-7.444l1.12.024a8.446 8.446 0 018.236 8.586z"
            ></path>
            <path
                fill="#FDC068"
                d="M74.83 43.26l-1.984-.233c-1.097-.14-1.89-1.12-1.75-2.217l.28-2.287c.14-1.096 1.12-1.89 2.217-1.75 1.096.14 1.89 1.12 1.75 2.217l-.514 4.27z"
            ></path>
            <path
                fill="#BE6361"
                d="M82.482 23.31a5.98 5.98 0 01-3.5-.303l-.326-.14c-3.64-1.517-7.724.956-8.074 4.876L70 34.16l19.017 1.75.583-6.347c.35-3.943-3.243-7.116-7.117-6.253z"
            ></path>
            <path
                fill="#000046"
                d="M70.374 29.76l-.404 4.392L88.976 35.9l.404-4.391-19.006-1.748z"
            ></path>
            <path
                fill="#BE6361"
                d="M99.26 37.24h-.047l-39.55-3.64a.39.39 0 01-.35-.42.39.39 0 01.42-.35l39.55 3.617a.39.39 0 01.35.42c0 .21-.187.373-.374.373z"
            ></path>
            <path
                fill="#000046"
                d="M73.266 75.04l-3.686-.047.956-3.196c1.214-4.34-.256-8.983-3.71-11.877l-5.436-4.503 2.24-2.684 5.436 4.504c4.527 3.756 6.44 9.846 4.854 15.493l-.654 2.31zM44.123 67.06H36.82a.393.393 0 01-.397-.397.38.38 0 01.396-.396h7.304a2.5 2.5 0 002.497-2.497v-2.45c0-.21.163-.397.396-.397a.38.38 0 01.397.397v2.45c0 1.797-1.47 3.29-3.29 3.29zM87.196 84.327a.322.322 0 01-.303-.234l-1.844-7.7c-.046-.163.07-.326.234-.373.163-.047.326.07.373.233l1.843 7.7c.047.164-.07.327-.233.374h-.07zM64.633 148.68c-.047 0-.094 0-.14-.023-.14-.07-.21-.257-.14-.397.373-.77 1.446-3.78 1.516-4.037l5.227-22.47a.335.335 0 01.373-.233c.164.047.257.21.234.373l-5.227 22.517c-.047.14-1.143 3.29-1.563 4.107-.07.093-.164.163-.28.163zM40.95 146.23a.309.309 0 01-.303-.303v-6.814c0-.163.14-.303.303-.303.163 0 .303.14.303.303v6.814c0 .163-.14.303-.303.303zM49.816 87.71a.332.332 0 01-.303-.21l-1.517-5.32a.3.3 0 01.21-.373.3.3 0 01.374.21l1.516 5.32a.3.3 0 01-.21.373h-.07zM95.153 94.477c-.047 0-.07 0-.117-.024l-2.403-.98c-.164-.07-.234-.233-.164-.396.07-.164.234-.234.397-.164l2.403.98c.164.07.234.234.164.397a.303.303 0 01-.28.187zM77.536 24.897a.332.332 0 01-.303-.21.3.3 0 01.21-.374l4.106-1.166a.3.3 0 01.374.21.3.3 0 01-.21.373l-4.107 1.167h-.07zM109.246 206.243H17.663v.957h91.583v-.957z"
            ></path>
            <path
                fill="#fff"
                d="M154.841 110.927h15.96v-22.82h-15.96l-9.474 11.41 9.474 11.41z"
            ></path>
            <path
                fill="#F9D0B5"
                d="M170.801 111.51h-15.96a.573.573 0 01-.443-.21l-9.474-11.41a.57.57 0 010-.747l9.474-11.41c.116-.14.28-.21.443-.21h15.96c.327 0 .583.257.583.584v22.82a.577.577 0 01-.583.583zm-15.68-1.167h15.097V88.69h-15.097l-8.983 10.827 8.983 10.826z"
            ></path>
            <path
                fill="#fff"
                d="M162.937 72.987h15.447V49.63h-15.447l-5.086 11.667 5.086 11.69z"
            ></path>
            <path
                fill="#F9D0B5"
                d="M178.384 73.57h-15.446a.589.589 0 01-.537-.35l-5.087-11.69a.545.545 0 010-.467l5.087-11.666a.589.589 0 01.537-.35h15.446c.327 0 .584.257.584.583v23.357a.578.578 0 01-.584.583zm-15.073-1.166h14.49v-22.19h-14.49l-4.83 11.083 4.83 11.106z"
            ></path>
            <path
                fill="#fff"
                d="M190.867 30.147l-10.033-9.31-10.033 9.31v176.377h20.066V30.147z"
            ></path>
            <path
                fill="#F9D0B5"
                d="M190.867 207.107H170.8a.578.578 0 01-.583-.584V30.147c0-.164.07-.327.186-.42l10.034-9.31c.233-.21.56-.21.793 0l10.033 9.31a.583.583 0 01.187.42v176.376a.578.578 0 01-.583.584zm-19.484-1.167h18.9V30.403l-9.45-8.773-9.45 8.773V205.94z"
            ></path>
            <path fill="#000046" d="M178.081 135.147l-7.28 8.796.046-10.873 7.234 2.077z"></path>
            <path
                fill="#000046"
                d="M170.8 144.527c-.07 0-.14 0-.21-.024-.233-.093-.396-.303-.373-.56l.047-10.873a.61.61 0 01.233-.467c.14-.116.327-.14.513-.093l7.234 2.077c.186.046.35.21.396.396.047.187.024.397-.116.537l-7.28 8.797a.575.575 0 01-.444.21zm.63-10.687l-.046 8.47 5.67-6.86-5.624-1.61zM178.081 93.94l-7.28 8.797.046-10.897 7.234 2.1z"
            ></path>
            <path
                fill="#000046"
                d="M170.8 103.32c-.07 0-.14 0-.21-.023-.233-.094-.396-.304-.373-.56l.047-10.897c0-.187.093-.35.233-.467.14-.116.327-.14.513-.093l7.234 2.1c.186.047.326.21.396.397.047.186.024.396-.116.536l-7.28 8.797a.575.575 0 01-.444.21zm.63-10.71l-.046 8.493 5.67-6.86-5.624-1.633zM200.785 93.753h-18.76V70.397h18.76l7.77 10.546-7.77 12.81z"
            ></path>
            <path
                fill="#000046"
                d="M200.785 94.337h-18.76a.578.578 0 01-.584-.584V70.398c0-.327.257-.584.584-.584h18.76c.186 0 .35.094.466.234l7.77 10.547a.56.56 0 01.024.653l-7.77 12.81a.57.57 0 01-.49.28zm-18.177-1.167h17.85l7.397-12.203-7.374-9.987h-17.873v22.19z"
            ></path>
            <path
                fill="#F9D0B5"
                d="M191.263 29.727l-10.033-9.31a.573.573 0 00-.63-.117.59.59 0 00-.35.537v185.896c0 .164.07.304.187.42a.543.543 0 00.396.164h.024l10.033-.21c.327 0 .56-.257.56-.584V30.147a.546.546 0 00-.187-.42z"
            ></path>
            <path fill="#000046" d="M189 121.8l1.867 5.087v-7.56L189 121.8z"></path>
            <path
                fill="#000046"
                d="M190.867 127.47c-.233 0-.466-.14-.536-.373l-1.867-5.087a.548.548 0 01.093-.56l1.867-2.473c.14-.21.42-.28.653-.21.234.07.397.303.397.56v7.56c0 .28-.21.513-.49.583h-.117zm-1.213-5.577l.63 1.704v-2.544l-.63.84zM183.283 72.987l8.05 9.753V69.487l-8.05 3.5z"
            ></path>
            <path
                fill="#000046"
                d="M191.333 83.323a.573.573 0 01-.443-.21l-8.05-9.753a.574.574 0 01-.117-.513.566.566 0 01.327-.397l8.05-3.5c.186-.07.396-.07.56.047.163.116.256.28.256.49V82.74a.604.604 0 01-.396.56c-.047.023-.117.023-.187.023zm-7.117-10.103l6.534 7.91V70.397l-6.534 2.823z"
            ></path>
            <path
                fill="#F9D0B5"
                d="M223.65 110.017l-9.474-11.41a.573.573 0 00-.443-.21H192.15a.578.578 0 00-.584.583v22.82c0 .327.257.583.584.583h21.583c.163 0 .327-.07.443-.21l9.474-11.41a.568.568 0 000-.746z"
            ></path>
            <path
                fill="#fff"
                d="M210.585 121.8h-21.583V98.98h21.583l9.474 11.41-9.474 11.41z"
            ></path>
            <path
                fill="#F9D0B5"
                d="M210.585 122.383h-21.584a.577.577 0 01-.583-.583V98.98c0-.327.257-.583.583-.583h21.584c.163 0 .326.07.443.21l9.473 11.41a.566.566 0 010 .746l-9.473 11.41a.575.575 0 01-.443.21zm-21-1.166h20.72l8.983-10.827-8.983-10.827h-20.72v21.654zM190.867 197.843H170.8a.578.578 0 00-.583.584v8.073c0 .327.256.583.583.583h20.067a.577.577 0 00.583-.583v-8.073a.578.578 0 00-.583-.584zM190.867 180.693H170.8a.578.578 0 00-.583.584v8.073c0 .327.256.583.583.583h20.067a.577.577 0 00.583-.583v-8.073a.578.578 0 00-.583-.584zM190.867 163.543H170.8a.578.578 0 00-.583.584v8.073c0 .327.256.583.583.583h20.067a.577.577 0 00.583-.583v-8.073a.578.578 0 00-.583-.584z"
            ></path>
            <path fill="#000046" d="M190.867 198.427h-10.033v8.073h10.033v-8.073z"></path>
            <path
                fill="#000046"
                d="M190.867 207.083h-10.034a.577.577 0 01-.583-.583v-8.073c0-.327.257-.584.583-.584h10.034c.326 0 .583.257.583.584v8.073a.577.577 0 01-.583.583zm-9.45-1.166h8.866v-6.907h-8.866v6.907zM190.867 181.277h-10.033v8.073h10.033v-8.073z"
            ></path>
            <path
                fill="#000046"
                d="M190.867 189.933h-10.034a.577.577 0 01-.583-.583v-8.073c0-.327.257-.584.583-.584h10.034c.326 0 .583.257.583.584v8.073a.577.577 0 01-.583.583zm-9.45-1.166h8.866v-6.907h-8.866v6.907zM190.867 164.127h-10.033v8.073h10.033v-8.073z"
            ></path>
            <path
                fill="#000046"
                d="M190.867 172.783h-10.034a.577.577 0 01-.583-.583v-8.073c0-.327.257-.584.583-.584h10.034c.326 0 .583.257.583.584v8.073a.577.577 0 01-.583.583zm-9.45-1.166h8.866v-6.907h-8.866v6.907z"
            ></path>
            <path
                fill="#F9D0B5"
                d="M190.867 35.607H170.8a.577.577 0 00-.583.583v8.074c0 .326.256.583.583.583h20.067a.578.578 0 00.583-.584V36.19a.578.578 0 00-.583-.583z"
            ></path>
            <path fill="#000046" d="M190.867 36.19h-10.033v8.074h10.033V36.19z"></path>
            <path
                fill="#000046"
                d="M190.867 44.847h-10.034a.578.578 0 01-.583-.584V36.19c0-.326.257-.583.583-.583h10.034c.326 0 .583.257.583.583v8.074a.578.578 0 01-.583.583zm-9.45-1.167h8.866v-6.907h-8.866v6.907z"
            ></path>
            <path
                fill="#fff"
                d="M156.288 135.147h18.783V111.79h-18.783l-7.77 10.547 7.77 12.81z"
            ></path>
            <path
                fill="#F9D0B5"
                d="M175.07 135.73h-18.783a.569.569 0 01-.49-.28l-7.77-12.81c-.116-.21-.117-.467.023-.653l7.77-10.547a.61.61 0 01.467-.233h18.783c.327 0 .584.256.584.583v23.357a.578.578 0 01-.584.583zm-18.456-1.167h17.873v-22.19H156.59l-7.373 9.987 7.397 12.203z"
            ></path>
            <path
                fill="#F9D0B5"
                d="M178.384 111.207h-18.76a.61.61 0 00-.467.233l-7.77 10.547a.56.56 0 00-.023.653l7.77 12.81c.116.163.303.28.49.28h18.76a.578.578 0 00.583-.583V111.79a.577.577 0 00-.583-.583z"
            ></path>
            <path
                fill="#fff"
                d="M150.734 93.753h24.336V70.397h-24.336l-6.09 10.546 6.09 12.81z"
            ></path>
            <path
                fill="#F9D0B5"
                d="M175.071 94.339h-24.337c-.233 0-.42-.14-.537-.327l-6.09-12.81c-.093-.163-.07-.373.024-.537l6.09-10.546c.093-.187.303-.28.513-.28h24.337c.326 0 .583.256.583.583v23.357c0 .303-.257.56-.583.56zm-23.964-1.167h23.38v-22.19h-23.426l-5.764 9.987 5.81 12.203z"
            ></path>
            <path
                fill="#F9D0B5"
                d="M178.384 69.813h-24.313a.64.64 0 00-.513.28l-6.09 10.547a.618.618 0 00-.024.537l6.09 12.81a.57.57 0 00.537.326h24.313a.578.578 0 00.584-.583V70.397a.578.578 0 00-.584-.584zM207.69 61.064l-5.086-11.667a.591.591 0 00-.537-.35H186.62a.578.578 0 00-.583.583v23.357c0 .327.257.583.583.583h15.447c.233 0 .443-.14.537-.35l5.086-11.69a.545.545 0 000-.466z"
            ></path>
            <path
                fill="#fff"
                d="M198.732 72.987h-15.447V49.63h15.447l5.086 11.667-5.086 11.69z"
            ></path>
            <path
                fill="#F9D0B5"
                d="M198.731 73.57h-15.446a.578.578 0 01-.584-.583V49.63c0-.326.257-.583.584-.583h15.446c.234 0 .444.14.537.35l5.087 11.667c.07.14.07.326 0 .466l-5.087 11.69a.589.589 0 01-.537.35zm-14.863-1.166h14.49l4.83-11.107-4.83-11.083h-14.49v22.19z"
            ></path>
            <path
                fill="#F9D5FF"
                d="M114.66 45.617v-2.334c3.103 0 8.377-5.436 13.51-10.71 7.14-7.35 14.513-14.956 21.233-14.956v2.333c-5.74 0-13.09 7.56-19.576 14.233-5.95 6.137-11.084 11.434-15.167 11.434z"
            ></path>
            <defs>
                <linearGradient
                    id="paint0_linear"
                    x1="207.655"
                    x2="207.655"
                    y1="167.597"
                    y2="205.637"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FFD8A1"></stop>
                    <stop offset="0.996" stopColor="#fff"></stop>
                </linearGradient>
                <linearGradient
                    id="paint1_linear"
                    x1="79.599"
                    x2="79.599"
                    y1="89.337"
                    y2="55.452"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#6B9C83"></stop>
                    <stop offset="0.401" stopColor="#A6A6A4"></stop>
                    <stop offset="0.501" stopColor="#9F9FC8"></stop>
                    <stop offset="0.591" stopColor="#9FCCEC"></stop>
                    <stop offset="1" stopColor="#FFE7B0"></stop>
                </linearGradient>
                <linearGradient
                    id="paint2_linear"
                    x1="70.826"
                    x2="70.826"
                    y1="89.337"
                    y2="55.452"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#6B9C83"></stop>
                    <stop offset="0.401" stopColor="#A6A6A4"></stop>
                    <stop offset="0.501" stopColor="#9F9FC8"></stop>
                    <stop offset="0.591" stopColor="#9FCCEC"></stop>
                    <stop offset="1" stopColor="#FFE7B0"></stop>
                </linearGradient>
                <linearGradient
                    id="paint3_linear"
                    x1="75.587"
                    x2="75.587"
                    y1="201.121"
                    y2="80.62"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#77879D"></stop>
                    <stop offset="0.089" stopColor="#A1978E"></stop>
                    <stop offset="0.188" stopColor="#C9A780"></stop>
                    <stop offset="0.279" stopColor="#E5B275"></stop>
                    <stop offset="0.358" stopColor="#F7B96F"></stop>
                    <stop offset="0.415" stopColor="#FDBB6D"></stop>
                    <stop offset="0.499" stopColor="#FDBB9F"></stop>
                    <stop offset="0.599" stopColor="#D1D2D1"></stop>
                    <stop offset="1" stopColor="#FECEAA"></stop>
                </linearGradient>
                <linearGradient
                    id="paint4_linear"
                    x1="48.883"
                    x2="48.883"
                    y1="201.22"
                    y2="83.12"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#77879D"></stop>
                    <stop offset="0.089" stopColor="#A1978E"></stop>
                    <stop offset="0.188" stopColor="#C9A780"></stop>
                    <stop offset="0.279" stopColor="#E5B275"></stop>
                    <stop offset="0.358" stopColor="#F7B96F"></stop>
                    <stop offset="0.415" stopColor="#FDBB6D"></stop>
                    <stop offset="0.499" stopColor="#FDBB9F"></stop>
                    <stop offset="0.599" stopColor="#D1D2D1"></stop>
                    <stop offset="1" stopColor="#FECEAA"></stop>
                </linearGradient>
                <linearGradient
                    id="paint5_linear"
                    x1="70.824"
                    x2="70.824"
                    y1="201.22"
                    y2="83.12"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#77879D"></stop>
                    <stop offset="0.089" stopColor="#A1978E"></stop>
                    <stop offset="0.188" stopColor="#C9A780"></stop>
                    <stop offset="0.279" stopColor="#E5B275"></stop>
                    <stop offset="0.358" stopColor="#F7B96F"></stop>
                    <stop offset="0.415" stopColor="#FDBB6D"></stop>
                    <stop offset="0.499" stopColor="#FDBB9F"></stop>
                    <stop offset="0.599" stopColor="#D1D2D1"></stop>
                    <stop offset="1" stopColor="#FECEAA"></stop>
                </linearGradient>
                <linearGradient
                    id="paint6_linear"
                    x1="61.944"
                    x2="61.944"
                    y1="89.337"
                    y2="55.452"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#6B9C83"></stop>
                    <stop offset="0.401" stopColor="#A6A6A4"></stop>
                    <stop offset="0.501" stopColor="#9F9FC8"></stop>
                    <stop offset="0.591" stopColor="#9FCCEC"></stop>
                    <stop offset="1" stopColor="#FFE7B0"></stop>
                </linearGradient>
            </defs>
        </svg>
    )
}

export default Icon
